const privileges = [
    /* 0 */ "employeeModal",
    /* 1 */ "externalModal",
    /* 2 */ "placeModal",
    /* 3 */ "plantModal",
    /* 4 */ "addFieldFacilitator",
    /* 5 */ "filterTable",
    /* 6 */ "softDeleteFarmer",
    /* 7 */ "deleteFarmer",
    /* 8 */ "softDeleteFieldFacilitator",
    /* 9 */ "deleteFieldFacilitator",
    /* 10 */ "filterTableByRM",
    /* 11 */ "filterTableByUM",
    /* 12 */ "filterTableByFC",
    /* 13 */ "filterTableByFF",
    /* 14 */ "filterTableByFarmer",
    /* 15 */ "filterTableByMU",
    /* 16 */ "filterTableByTA",
    /* 17 */ "filterTableByVillage",
    /* 18 */ "softDeleteLahan",
    /* 19 */ "deleteLahan",
    /* 20 */ "verificationLahanByFC",
    /* 21 */ "verificationLahanByUM",
    /* 22 */ "editDataLahan:latLong",
    /* 23 */ "verificationSosialisasiTanamByFC",
    /* 24 */ "verificationSosialisasiTanamByUM",
    /* 25 */ "softDeleteSosialisasiTanam",
    /* 26 */ "deleteSosialisasiTanam",
    /* 27 */ "changeFarmerPIC/FF",
    /* 28 */ "verificationPenilikanLubangByFC",
    /* 29 */ "verificationPenilikanLubangByUM",
]

const userAccess = {
    // DASHBOARD
        "IT PROJECT MANAGER": [ ...privileges ],
        "IT MANAGER": [ ...privileges ],
        "IT OFFICER": [ ...privileges ],
        "MOBILE APP DEVELOPER": [ ...privileges ],
        "WEB DEVELOPER": [ ...privileges ],
        "PROGRAM MANAGER": [ ...getPrivileges([0,1,2,3,5,10,11,12,13,14,15,16,17]) ],
        "OFFICE MANAGER": [],
        "PROGRAM COORDINATOR": [],
        "UNIT MANAGER": [ ...getPrivileges([1,2,5,6,8,12,13,14,16,17,20,21,22,24,25]) ],
        "FIELD COORDINATOR": [ ...getPrivileges([1,2,6,8,20]) ],
        "FIELD COORDINATOR PROGRAM": [],
        "ADMIN ASSISTANT & GA": [],
        "ACCOUNTING": [],
        "WEBSITE CONTENT OFFICER": [],
        "DRIVER": [],
        "OFFICE BOY": [],
        "HRD OFFICER": [],
        "GIS STAFF": [],
        "FUND RAISING MANAGER": [],
        "IMPACT OFFICER": [],
        "FORESTRY STAFF": [],
        "NURSERY MANAGER": [],
        "NURSERY": [],
        "ADMINISTRATION STAFF": [],
        "TRAINING PROGRAM OFFICER": [],
        "REGIONAL MANAGER": [],
        "PLANNING MANAGER": [],
        "SOCIAL OFFICER": [],
        "PROCUREMENT & INVENTORY": [],
}
console.log(userAccess)

function getPrivileges(privilegesIndex) {
    let userPrivileges = []
    privilegesIndex.forEach(index => {
        userPrivileges.push(privileges[index])
    })
    return userPrivileges
}

export {
    userAccess,
    privileges
}